import { HttpHeaders } from '@angular/common/http';

export class HttpClientExtensions {

    static skipBearerInterceptor() {
        return new HttpHeaders().set('Skip-Bearer-Interceptor', 'true');
    }
}